export default __webpack_public_path__ + "static/people-hugging-487cda397e2ea36cc661ad967197c5a1.webp";